import { defineMessages } from 'react-intl';

export default defineMessages({
    nextRepayment: {
        id: '_.outstanding_view.nextRepayment',
        defaultMessage: 'Next repayment'
    },
    nextRepaymentDetail: {
        id: '_.outstanding_view.nextRepaymentDetail',
        defaultMessage: '{nextRepaymentAmount} on {nextRepaymentDate}'
    },
    interestOnlyPillName: {
        id: '_.outstanding_view.interestOnlyPillName',
        defaultMessage: 'Interest Only'
    },
    outstandingBalance: {
        id: '_.outstanding_view.outstandingBalance',
        defaultMessage: "Today's outstanding balance"
    },
    currentPrincipal: {
        id: '_.outstanding_view.currentPrincipal',
        defaultMessage: 'Current principal'
    },
    interestAccrued: {
        id: '_.outstanding_view.interestAccrued',
        defaultMessage: 'Interest'
    }
});
